import React, { useCallback, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { Aboutus, carousel1, carousel2, carousel3, service1, service2, service3, service4, service5, service6 } from "../../../assets/static";
import { toAbsoluteUrl } from "../../../helpers";

export default function Home() {
  const carouselRef = useRef(null);
  const carouselInitialized = useRef(false);

  const initOwlCarousel = useCallback(() => {
    if (carouselInitialized.current) return;
    if (typeof window.jQuery === "undefined" || typeof window.jQuery.fn.owlCarousel === "undefined") return;
    const $ = window.jQuery;
    const $el = $(carouselRef.current);
    if ($el.length && $el.children().length > 0) {
      $el.owlCarousel({
        autoplay: true,
        smartSpeed: 1500,
        loop: true,
        dots: false,
        nav: false,
        responsive: {
          0: { items: 1 },
          576: { items: 2 },
          768: { items: 3 },
          992: { items: 4 },
          1200: { items: 5 },
        },
      });
      carouselInitialized.current = true;
    }
  }, []);

  useEffect(() => {
    const node = carouselRef.current;

    // Try immediately in case scripts are already cached/loaded
    initOwlCarousel();

    // Poll for jQuery + owlCarousel availability (handles first load / no cache)
    const interval = setInterval(() => {
      initOwlCarousel();
      if (carouselInitialized.current) clearInterval(interval);
    }, 300);

    // Cleanup
    return () => {
      clearInterval(interval);
      if (node && typeof window.jQuery !== "undefined") {
        const $ = window.jQuery;
        const $el = $(node);
        if ($el.data && $el.data("owl.carousel")) {
          try {
            $el.owlCarousel("destroy");
          } catch (e) {
            /* ignore */
          }
        }
      }
      carouselInitialized.current = false;
    };
  }, [initOwlCarousel]);

  return (
    <>
      <html lang="en">
        <Helmet>
          <meta charset="utf-8" />
          <title>SART WITH K</title>
          <meta content="width=device-width, initial-scale=1.0" name="viewport" />
          <meta content="SARTWITHK" name="keywords" />
          <meta content="Welcome to SARTWITHK, your ultimate destination for authentic cosmetics and skincare products, right here in Cambodia! Our mobile app is designed to bring high-quality beauty essentials straight to your fingertips, ensuring a seamless and delightful shopping experience for every beauty enthusiast." name="description" />

          <link rel="preconnect" href="https://fonts.gstatic.com" />
          <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap" rel="stylesheet" />

          <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.0/css/all.min.css" rel="stylesheet" />
          <link href={toAbsoluteUrl("/static/lib/animate/animate.min.css")} rel="stylesheet" />
          <link rel="stylesheet" href={toAbsoluteUrl("/static/lib/owlcarousel/assets/owl.carousel.min.css")} />
          <link rel="stylesheet" href={toAbsoluteUrl("/static/lib/tempusdominus/css/tempusdominus-bootstrap-4.min.css")} />
          <link href={toAbsoluteUrl("/static/css/styles.css")} rel="stylesheet" />

          <script src="https://code.jquery.com/jquery-3.4.1.min.js"></script>
          <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
          <script src={toAbsoluteUrl("/static/lib/easing/easing.min.js")}></script>
          <script src={toAbsoluteUrl("/static/lib/waypoints/waypoints.min.js")}></script>
          <script src={toAbsoluteUrl("/static/lib/counterup/counterup.min.js")}></script>
          <script src={toAbsoluteUrl("/static/lib/owlcarousel/owl.carousel.min.js")}></script>
          <script src={toAbsoluteUrl("/static/lib/tempusdominus/js/moment.min.js")}></script>
          <script src={toAbsoluteUrl("/static/lib/tempusdominus/js/moment-timezone.min.js")}></script>
          <script src={toAbsoluteUrl("/static/lib/tempusdominus/js/tempusdominus-bootstrap-4.min.js")}></script>
          <script src={toAbsoluteUrl("/static/mail/jqBootstrapValidation.min.js")}></script>
          <script src={toAbsoluteUrl("/static/mail/contact.js")}></script>
          <script src={toAbsoluteUrl("/static/js/main.js")}></script>
        </Helmet>
        <body>
          <div id="home-section" style={{ width: "100%", height: "100%", position: "relative" }}>
            <div className="container-fluid bg-light d-none d-lg-block">
              <div className="row py-2 px-lg-5">
                <div className="col-lg-6 text-left mb-2 mb-lg-0">
                  <div className="d-inline-flex align-items-center">
                    <small>
                      <i className="fa fa-phone-alt mr-2"></i>
                      <a target="_blank" rel="noopener noreferrer" href="tel:+85599980101">
                        099 98 01 01
                      </a>
                    </small>
                    <small className="px-3">|</small>
                    <small>
                      <i className="fa fa-envelope mr-2"></i>
                      <a target="_blank" rel="noopener noreferrer" href="mailto:sartwithk@gmail.com">
                        sartwithk@gmail.com
                      </a>
                    </small>
                  </div>
                </div>
                <div className="col-lg-6 text-right">
                  <div className="d-inline-flex align-items-center">
                    <a className="text-primary px-2" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/kbeautyandcosmetics.k">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a className="text-primary px-2" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/kbeautyandcosmetics.k">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a className="text-primary pl-2" target="_blank" rel="noopener noreferrer" href="https://t.me/+C3QFY9kAQnU4NmNl">
                      <i className="fab fa-telegram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid p-0" style={{ position: "sticky", top: "0", zIndex: 4000 }}>
              <nav className="navbar navbar-expand-lg bg-white navbar-light py-3 py-lg-0 px-lg-5">
                <a
                  href="#home-section"
                  className="navbar-brand ml-lg-3"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.getElementById("home-section");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  <h3 className="m-0 text-primary">Kbeautyandcosmetics.k</h3>
                </a>
                <div className="d-flex d-lg-none align-items-center ml-auto mr-2">
                  <a target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/app/sartwithk/id6744243334" className="btn btn-sm btn-primary mr-2" style={{ padding: "0.25rem 0.5rem", fontSize: "0.75rem" }}>
                    <i className="fab fa-apple mr-1"></i> App
                  </a>
                  <a target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.udaya.kbeauty_sk" className="btn btn-sm btn-primary" style={{ padding: "0.25rem 0.5rem", fontSize: "0.75rem" }}>
                    <i className="fab fa-google-play mr-1"></i> Play
                  </a>
                </div>
                <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse justify-content-between px-lg-3" id="navbarCollapse">
                  <div className="navbar-nav m-auto py-0">
                    <a
                      href="#home-section"
                      className="nav-item nav-link"
                      onClick={(e) => {
                        e.preventDefault();
                        const el = document.getElementById("home-section");
                        if (el) el.scrollIntoView({ behavior: "smooth" });
                      }}
                    >
                      Home
                    </a>
                    <a
                      href="#about-section"
                      className="nav-item nav-link"
                      onClick={(e) => {
                        e.preventDefault();
                        const el = document.getElementById("about-section");
                        if (el) el.scrollIntoView({ behavior: "smooth" });
                      }}
                    >
                      About
                    </a>
                    <a
                      href="#our-app-section"
                      className="nav-item nav-link"
                      onClick={(e) => {
                        e.preventDefault();
                        const el = document.getElementById("our-app-section");
                        if (el) el.scrollIntoView({ behavior: "smooth" });
                      }}
                    >
                      Our App
                    </a>
                  </div>

                  <div className="d-none d-lg-flex align-items-center">
                    <a target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/app/sartwithk/id6744243334" className="btn btn-primary mr-2">
                      <i className="fab fa-apple mr-1"></i> App Store
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.udaya.kbeauty_sk" className="btn btn-primary">
                      <i className="fab fa-google-play mr-1"></i> Google Play
                    </a>
                  </div>
                </div>
              </nav>
            </div>
            <style>
              {`@media (max-width: 767.98px) {
            #header-carousel .carousel-item {
                min-height: 25vh !important;
            }
            #header-carousel .carousel-item img {
                min-height: 25vh !important;
            }
        }
        @media (min-width: 768px) {
            #header-carousel .carousel-item {
                min-height: 85vh !important;
            }
            #header-carousel .carousel-item img {
                min-height: 85vh !important;
            }
        }`}
            </style>
            <div className="container-fluid p-0 mb-5 pb-5">
              <div id="header-carousel" className="carousel slide carousel-fade" data-ride="carousel">
                <ol className="carousel-indicators">
                  <li data-target="#header-carousel" data-slide-to="0" className="active"></li>
                  <li data-target="#header-carousel" data-slide-to="1"></li>
                  <li data-target="#header-carousel" data-slide-to="2"></li>
                </ol>
                <div className="carousel-inner">
                  {[carousel1, carousel2, carousel3].map((carousel, i) => {
                    return (
                      <div className={`carousel-item position-relative ${i === 0 ? "active" : ""}`} style={{ minHeight: "85vh" }}>
                        <img className="position-absolute w-100 h-100" src={carousel} style={{ objectFit: "cover" }} alt={`SARTWITHK Carousel ${i + 1}`} />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="container-fluid py-5" id="about-section">
              <div className="container py-5">
                <div className="row align-items-center">
                  <div className="col-lg-6 pb-5 pb-lg-0">
                    <img className="img-fluid w-100" src={Aboutus} alt="About Us" />
                  </div>
                  <div className="col-lg-6">
                    <h6 className="d-inline-block text-primary text-uppercase bg-light py-1 px-2">About Us</h6>
                    <h1 className="mb-4">SART WITH K</h1>
                    <p className="pl-4 border-left border-primary">
                      Welcome to SARTWITHK, your ultimate destination for authentic cosmetics and skincare products, right here in Cambodia! Our mobile app is designed to bring high-quality beauty essentials straight to your fingertips, ensuring a seamless and delightful shopping experience for every beauty enthusiast.
                      <br />
                      <br />
                      We’ve designed our app to provide a user-friendly experience tailored to your needs. You can easily explore products by brand or category, whether you’re looking for foams, creams, sunscreens, or other skincare essentials. With detailed product descriptions, you’ll find all the information you need to make confident choices.
                      <br />
                      <br />
                      Stay up-to-date with our exclusive promotions and discounts, and enjoy fast, secure online ordering with convenient payment options.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid px-0 py-5 my-5" id="our-app-section">
              <div className="row mx-0 justify-content-center text-center">
                <div className="col-lg-6">
                  <h6 className="d-inline-block bg-light text-primary text-uppercase py-1 px-2">Our App</h6>
                  <h1>SART WITH K</h1>
                </div>
              </div>
              <div ref={carouselRef} className="owl-carousel service-carousel">
                {[service1, service2, service3, service4, service5, service6].map((service, i) => {
                  return (
                    <div className="service-item position-relative" key={i}>
                      <img className="img-fluid" src={service} alt={`SARTWITHK App Screenshot ${i + 1}`} />
                      <div className="service-text text-center">
                        <div className="w-100 bg-white text-center p-3">
                          <a className="btn btn-primary btn-sm mr-1" href="https://apps.apple.com/app/sartwithk/id6744243334" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-apple mr-1"></i> App Store
                          </a>
                          <a className="btn btn-primary btn-sm" href="https://play.google.com/store/apps/details?id=com.udaya.kbeauty_sk" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-google-play mr-1"></i> Google Play
                          </a>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* Footer Section */}
            <div className="footer container-fluid position-relative bg-dark py-5" style={{ marginTop: 90 }}>
              <div className="container pt-5">
                <div className="row">
                  <div className="col-lg-6 pr-lg-5 mb-5">
                    <a href="index.html" className="navbar-brand">
                      <h1 className="mb-3 text-primary">Kbeautyandcosmetics.k</h1>
                    </a>
                    <h5 className="text-white">Find us on</h5>
                    <div className="d-flex justify-content-start mt-4 mb-5">
                      <a className="btn btn-lg btn-primary btn-lg-square mr-2" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/kbeautyandcosmetics.k">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a className="btn btn-lg btn-primary btn-lg-square mr-2" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/kbeautyandcosmetics.k">
                        <i className="fab fa-instagram"></i>
                      </a>
                      <a className="btn btn-lg btn-primary btn-lg-square" target="_blank" rel="noopener noreferrer" href="https://t.me/+C3QFY9kAQnU4NmNl">
                        <i className="fab fa-telegram"></i>
                      </a>
                    </div>
                    <h5 className="text-white text-uppercase mb-4">Contact Us</h5>
                    <div className="d-flex justify-content-start mt-4">
                      <div className="d-flex align-items-center">
                        <a className="btn btn-lg btn-primary btn-lg-square mr-2" target="_blank" rel="noopener noreferrer" href="tel:+85599980101">
                          <i className="fa fa-phone-alt"></i>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="tel:+85599980101" className="text-white">
                          099 98 01 01
                        </a>
                      </div>
                    </div>
                    <div className="d-flex justify-content-start mt-4">
                      <div className="d-flex align-items-center">
                        <a className="btn btn-lg btn-primary btn-lg-square mr-2" target="_blank" rel="noopener noreferrer" href="mailto:sartwithk@gmail.com">
                          <i className="fa fa-envelope"></i>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="mailto:sartwithk@gmail.com" className="text-white">
                          sartwithk@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 pl-lg-5">
                    <div className="row">
                      <div className="col-lg-6 mb-5">
                        <h5 className="text-white text-uppercase mb-4">Our Location</h5>
                        {/* Responsive Map Styling */}
                        <style>
                          {` .map-container {
                                position: relative;
                                width: 100%;
                                overflow: hidden;
                            }
                            .map-container iframe {
                                border: 0;
                                width: 100%;
                            }
                            @media(max-width: 767.98px) {
                                .map-container {
                                    height: 250px;
                                }
                                .map-container iframe {
                                    height: 250px;
                                }
                            }
                            @media(min-width: 768px) {
                                .map-container {
                                    height: 400px;
                                    width: 650px;
                                }
                                .map-container iframe {
                                    height: 400px;
                                    width: 650px;
                                }
                            }`}
                        </style>
                        <p className="text-white mb-2">
                          <strong>Main Branch</strong>
                        </p>
                        <div className="map-container mb-4">
                          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3909.2033508538566!2d104.8878751!3d11.537265600000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3109512e97c81d47%3A0x2090cecb4b4ec813!2sKbeautyandcosmetics.k!5e0!3m2!1sen!2sus!4v1756715091847!5m2!1sen!2sus" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Kbeautyandcosmetics.k Location"></iframe>
                        </div>
                        <p className="text-white mb-2">
                          <strong>Preah Sisowath Branch</strong>
                        </p>
                        <div className="map-container">
                          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3908.8433050772123!2d104.9252103!3d11.563088599999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3109510009ea8d51%3A0xcb6b4dad66830781!2zS2JlYXV0eWFuZGNvc21ldGljcy5rICjhnp_hnrbhnoHhnrbhnpzhnrfhnpHhn5Lhnpnhnrbhnpvhn5Dhnpnhnpbhn5Lhnprhn4fhnp_hn4rhnrjhnp_hnrvhnpzhno_hn5LhnpDhnrcp!5e0!3m2!1sen!2skh!4v1781142712834!5m2!1sen!2skh" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Kbeautyandcosmetics.k Preah Sisowath Branch"></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid bg-dark text-light border-top py-4" style={{ borderColor: "rgba(256, 256, 256, .15)" }}>
              <div className="container">
                <div className="row">
                  <div className="col-md-6 text-center text-md-left mb-3 mb-md-0">
                    <p className="m-0 text-white">
                      &copy; <span>Kbeautyandcosmetics.k</span>. All Rights Reserved.
                    </p>
                  </div>
                  <div className="col-md-6 text-center text-md-right">
                    <a target="_blank" rel="noopener noreferrer" href="https://kbeackngix.utebi.com/privacy-policy" className="m-0 text-white">
                      Privacy Policy
                    </a>{" "}
                    |{" "}
                    <a target="_blank" rel="noopener noreferrer" href="https://kbeackngix.utebi.com/term-and-condition" className="m-0 text-white">
                      Terms &amp; Condition
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </body>
      </html>
    </>
  );
}
